<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {
          env: '',
          ip_address: '',
          host: '',
          endpoint: '',
          user_agent: '',
          method: '',
          parameters: {},
          headers: {},
          created_at: null
        }
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      default: false
    },
    summary: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<template>
  <div>
    <a-card size="small" type="inner" :title="title">
      <a-skeleton :loading="loading" active>
        <div>
          <a-row>
            <a-col :span="6"><strong>Environment</strong></a-col>
            <a-col :span="18"><p>{{ item.env }}</p></a-col>
          </a-row>
          <a-row>
            <a-col :span="6"><strong>Host</strong></a-col>
            <a-col :span="18"><p><code>{{ item.host }}</code></p></a-col>
          </a-row>
          <a-row>
            <a-col :span="6"><strong>IP Address</strong></a-col>
            <a-col :span="18"><p><code>{{ item.ip_address }}</code></p></a-col>
          </a-row>
          <a-row>
            <a-col :span="6"><strong>Method</strong></a-col>
            <a-col :span="18"><p><code>{{ item.method }}</code></p></a-col>
          </a-row>
          <a-row>
            <a-col :span="6"><strong>Endpoint</strong></a-col>
            <a-col :span="18"><p><code>{{ item.endpoint }}</code></p></a-col>
          </a-row>
          <a-row>
            <a-col :span="6"><strong>User Agent</strong></a-col>
            <a-col :span="18"><p><code>{{ item.user_agent }}</code></p></a-col>
          </a-row>
        </div>
      </a-skeleton>
    </a-card>

    <a-card size="small" type="inner" :style="{ 'margin-top': '15px' }" v-if="summary">
      <a-tabs defaultActiveKey="parameters">
        <a-tab-pane tab="Parameters" key="parameters">
          <a-empty v-if="item.parameters.length < 1"/>

          <a-row v-for="(value,key) in item.parameters" :key="`parameters-${key}`">
            <a-col :span="6"><strong>{{ key }}</strong></a-col>
            <a-col :span="18"><p><code>{{ value }}</code></p></a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane tab="Headers" key="headers">
          <a-empty v-if="item.headers.length < 1"/>

          <a-row v-for="(value,key) in item.headers" :key="`parameters-${key}`">
            <a-col :span="6"><strong>{{ key }}</strong></a-col>
            <a-col :span="18"><p><code>{{ typeof value === 'string' ? value : value.toString() }}</code></p></a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane tab="Source" key="source">
          <json-source :source="item"/>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>
